import { Component, Input, Output, OnInit, ViewChild, TemplateRef, EventEmitter } from '@angular/core';

import { Subject } from 'rxjs';
import { DatePipe } from '@angular/common';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap/modal/modal.module';
import { ActivatedRoute, Router } from '@angular/router';

import { CalendarEvent, CalendarEventTimesChangedEvent, CalendarDateFormatter, CalendarMonthViewDay } from 'angular-calendar';
import { colors, division_colors } from '../colors'
import { CalendarFormatter } from '../calendar-common/calendar-formatter.provider'
import { concat } from 'rxjs/operators';
import { AuthService } from '../Services/auth.service';
import { CalendarService } from '../Services/calendar.service';
import { ListService } from '../Services/list.service';
import { StringUtil } from '../classes/StringUtil';
import { Logininfo } from '../classes/Loginifo';

@Component({
  selector: 'app-all-calendar',
  templateUrl: './all-calendar.component.html',
  styleUrls: ['./all-calendar.component.css'],
  providers: [
    {
      provide: CalendarDateFormatter,
      useClass: CalendarFormatter
    }
  ]
})
export class AllCalendarComponent implements OnInit {
  @ViewChild('eventView') eventView: TemplateRef<any>;
  @ViewChild('selectUser') selectUser: TemplateRef<any>;
  @Input()
  set acalref(val: boolean) {
    if (val) {
      this.getCalendar(this.viewDate);
      this.acalChange.emit(false);
    }
  }
  @Output() acalChange = new EventEmitter<boolean>();
  refresh: Subject<any> = new Subject();
  modalReference: NgbModalRef;

  logininfo: Logininfo = this.auth.loginID;
  view: string = 'month';
  viewDate: Date = new Date();
  locale: string = 'ja';
  allEvents: any[] = [];
  viewEvents: any[] = [];
  users: any[] = [];
  dispEvent: any = {
    id: '',
    title: '',
    start: '',
    end: '',
    startTime: '',
    endTime: '',
    allDay: false,
    meta: {
      type: '',
      contents: '',
      division: { division_code: '' },
      sales: { user_code: '' },
      user: { user_code: '' },
      customer: {},
      event: {},
      child: [],
      other: {},
      holiday: ''
    }
  };

  constructor(
    public auth: AuthService,
    public datePipe: DatePipe,
    private modal: NgbModal,
    private calendar: CalendarService,
    private list: ListService,
    private router: Router,
  ) { }

  ngOnInit() {
    this.viewEvents = [];
    this.getUsers();
    this.getCalendar(this.viewDate);
  }
  getCalendar(date: Date) {
    this.allEvents = [];
    this.calendar.getUserCal(null, null,
      this.viewDate.getFullYear(),
      this.viewDate.getMonth() + 1,
      this.viewDate.getDate(),
      this.logininfo.user_code
    ).subscribe((data: any[]) => {
      data.forEach(event => {
        let ev = this.json2CalEvent(event);
        this.allEvents.push(ev);
      });
      this.filterUsers(this.getSelectedUSers());
      this.refresh.next();
    });
  }
  getUsers() {
    this.users = [];
    this.list.getUserList().subscribe(
      (data: any[]) => {
        var divisionlist = [];
        data.forEach(usr => {
          var userInfo;
          userInfo = { user_code: usr.user_code, name: usr.user_family_name + ' ' + usr.user_name, selected: true };
          if (divisionlist[usr.division_code]) {
            let userlist = divisionlist[usr.division_code].list;
            userlist.push(userInfo);
            divisionlist[usr.division_code].list = userlist;
          } else {
            divisionlist[usr.division_code] = { division_code: usr.division_code, division_name: usr.division_name, division_short_name: usr.division_short_name, selected: true, listview: false, list: [userInfo] };
          }
        });
        divisionlist.forEach((info) => {
          this.users.push(info);
        });
      }
    );
  }

  eventClicked({ event }: { event: CalendarEvent }) {
    this.dispEvent = this.calEvent2ViewInfo(event);
    this.viewEventInfo();
  }
  viewEventInfo() {
    this.modalReference = this.modal.open(this.eventView, { centered: true });
    this.modalReference.result.then((result) => { });
  }
  checkDivChange(division_code) {
    this.users.forEach((group) => {
      if (group.division_code == division_code) {
        group.list.forEach((user) => {
          user.selected = group.selected;
        });
      }
    });
    this.filterUsers(this.getSelectedUSers());
  }
  checkUserChange() {
    this.filterUsers(this.getSelectedUSers());
  }

  getSelectedUSers() {
    var selected = [];
    this.users.forEach((group) => {
      var sel = group.list.filter((sales) => sales.selected).map((info) => info.user_code);
      Array.prototype.push.apply(selected, sel);
    });
    return selected;
  }
  filterUsers(selected) {
    this.viewEvents = this.allEvents.filter((val) => {
      if (selected.indexOf(val.meta.sales.user_code) >= 0) { return true };
      return false;
    });
  }
  json2CalEvent(info: any) {
    var color;
    if (info.meta.user && info.meta.user.division) {
      switch (info.meta.user.division.division_code) {
        case 1:
          color = division_colors.niconico;
          break;
        case 2:
          color = division_colors.hiraya;
          break;
        case 3:
          color = division_colors.tochi;
          break;
        default:
          color = division_colors.niconico;
      }
    } else {
      color = colors.red;
    }
    var event = {
      id: info.id ? info.id : null,
      title: info.title,
      start: new Date(info.start),
      end: info.end ? new Date(info.end) : null,
      allDay: info.allDay,
      meta: Object.assign({}, info.meta),
      color: color
    }
    return event;
  }
  calEvent2ViewInfo(event: any) {
    let startDate = StringUtil.date2Object(event.start);
    let endDate = StringUtil.date2Object(event.end);
    let startTime = StringUtil.date2ObjectTime(event.start);
    let endTime = StringUtil.date2ObjectTime(event.end);
    var info = {
      id: event.id ? event.id : null,
      title: event.title,
      start: startDate,
      end: (!event.allDay && endDate) ? endDate : null,
      startTime_hour: startTime ? startTime.hours : null,
      startTime_minute: startTime ? startTime.minutes : null,
      endTime_hour: (!event.allDay && endTime) ? endTime.hours : null,
      endTime_minute: (!event.allDay && endTime) ? endTime.minutes : null,
      allDay: event.allDay,
      meta: Object.assign({}, event.meta)
    }
    return info;
  }
  //顧客詳細へ
  customerDetail(id) {
    this.modalReference.close();
    this.router.navigate(['/detail/' + id]);
  }
  // サポートー＞ログインユーザのカレンダーに登録
  viewInfo2CalEvent(info: any) {
    let startDate = info.allDay ? StringUtil.Object2Str(info.start, '00:00') : StringUtil.Object2Str(info.start, info.startTime_hour + ":" + info.startTime_minute);
    let endDate = (!info.allDay && info.start && info.endTime_hour && info.endTime_minute) ? StringUtil.Object2Str(info.start, info.endTime_hour + ":" + info.endTime_minute) : null;
    var event = {
      id: info.id ? info.id : null,
      title: info.title,
      start: startDate,
      end: endDate,
      allDay: false,
      meta: Object.assign({}, info.meta)
    }
    return event;
  }
  copyEvent() {
    this.modalReference.close();
    var event = this.viewInfo2CalEvent(this.dispEvent);
    let baseid = event.id;
    event.id = null;
    event.title = 'サポート';
    this.allEvents = [];
    this.calendar.setUserCal(null, event, this.logininfo.user_code, baseid
    ).subscribe((data: any[]) => {
      data.forEach(event => {
        let ev = this.json2CalEvent(event);
        this.allEvents.push(ev);
      });
      this.filterUsers(this.getSelectedUSers());
      this.refresh.next();
      this.acalChange.emit(true);
    });
  }

  viewUserSelect(view) {
    if (view) {
      this.modalReference = this.modal.open(this.selectUser, { backdrop: true, windowClass: 'user-select-dialog' });
      this.modalReference.result.then((result) => { });
    }
  }
}
